module.exports = __webpack_public_path__ + "img/1.083a74a0.png";